export default "Escape Skagen åbnede i juli 2019.";